import { render, staticRenderFns } from "./SignupAccept.vue?vue&type=template&id=4fd8dc53&"
import script from "./SignupAccept.vue?vue&type=script&lang=js&"
export * from "./SignupAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports